import { Button } from '@/shared/components/ui/button';
import { Card, CardContent } from '@/shared/components/ui/card';
import { ROUTE_PATHS } from '@/shared/constants/routes';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { ArrowLeft, LayoutDashboard } from 'lucide-react';
import React from 'react';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith('/admin');

  const handleGoHome = () => {
    navigate({
      to: isAdminPath ? ROUTE_PATHS.DASHBOARD : ROUTE_PATHS.LOGIN,
    } as never);
  };

  const handleGoBack = () => navigate({ to: '..' });

  const title = isAdminPath
    ? '어드민 페이지를 찾을 수 없습니다'
    : '페이지를 찾을 수 없습니다';

  const content = (
    <Card className="border-none shadow-none">
      <CardContent className="flex flex-col items-center gap-4 pt-8 text-center">
        <p className="text-6xl font-bold text-ruda-primary">404</p>
        <h2 className="text-xl font-semibold">{title}</h2>
        <p className="max-w-md text-muted-foreground">
          요청하신 페이지가 존재하지 않거나 이동되었을 수 있습니다. URL을
          다시 확인해주세요.
        </p>
        <div className="flex gap-2 pt-2">
          <Button onClick={handleGoHome}>
            {isAdminPath ? (
              <>
                <LayoutDashboard className="mr-2 h-4 w-4" />
                대시보드로 이동
              </>
            ) : (
              '홈으로 이동'
            )}
          </Button>
          <Button variant="outline" onClick={handleGoBack}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            이전 페이지
          </Button>
        </div>
      </CardContent>
    </Card>
  );

  if (isAdminPath) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">{content}</div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-ruda-bg-secondary p-6">
      {content}
    </div>
  );
};
